"use client";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/uk";
import { ReactNode } from "react";

interface DateProviderProps {
    children: ReactNode;
}

export const DateProvider = ({ children }: DateProviderProps) => {
    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            localeText={{
                cancelButtonLabel: "Відмінити",
                okButtonLabel: "Підтвердити",
                datePickerToolbarTitle: "Оберіть дату",
            }}
            adapterLocale={"uk"}
        >
            {children}
        </LocalizationProvider>
    );
};
